import Cookies from "js-cookie";

const getLocalRefreshToken = () => {
  const user = JSON.parse(localStorage.getItem("userAuthToken"));
  return user?.refreshToken;
};

const getLocalAccessToken = () => {
  const user = JSON.parse(localStorage.getItem("userAuthToken"));
  return user?.accessToken;
};

const getUser = () => {
  return JSON.parse(localStorage.getItem("userAuthToken"));
};

const setUser = (user) => {
  Cookies.set("userAuthToken", JSON.stringify(user), { path: "/" });
  localStorage.setItem("userAuthToken", JSON.stringify(user));
};

const removeUser = () => {
  Cookies.remove("userAuthToken");
  localStorage.removeItem("userAuthToken");
  localStorage.removeItem("userDetail");
};

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  getUser,
  setUser,
  removeUser,
};

export default TokenService;
